import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-api-empty-view',
  templateUrl: './api-empty-view.component.html',
  styleUrl: './api-empty-view.component.scss'
})
export class ApiEmptyViewComponent {
  @Output() onRefresh = new EventEmitter();

  refresh(): void {
    this.onRefresh.emit();
  }

}
